const pricingTable01 = [
    {
        title: "BASIC",
        subtitle: "Basic features",
        price: "$9.99",
        term: "monthly",
        plans: [
            `<strong>5</strong> Domains`,
            `<strong>2 GB</strong> File upload`,
            `<strong>20 GB</strong> Secure storage`,
            `<strong>Unlimited</strong> bandwidth`
        ],
        buttonTitle: "Choose plan",
        buttonLink: "/page/pricing-packages",
    },
    {
        title: "STANDARD",
        subtitle: "MOST POPULAR",
        price: "$19.99",
        term: "monthly",
        plans: [
            `<strong>10</strong> Domains`,
            `<strong>2 GB</strong> File upload`,
            `<strong>40 GB</strong> Secure storage`,
            `<strong>Unlimited</strong> bandwidth`
        ],
        buttonTitle: "Choose plan",
        buttonLink: "/page/pricing-packages",
        popular: {
            isPopular: true
        }
    },
    {
        title: "PREMIUM",
        subtitle: "ALL YOU MAY NEED",
        price: "$29.99",
        term: "monthly",
        plans: [
            `<strong>20</strong> Domains`,
            `<strong>4 GB</strong> File upload`,
            `<strong>60 GB</strong> Secure storage`,
            `<strong>Unlimited</strong> bandwidth`
        ],
        buttonTitle: "Choose plan",
        buttonLink: "/page/pricing-packages",
    },
]

const pricingTable02 = [
    {
        icon: "line-icon-Boy",
        title: "STANDARD",
        price: "$800",
        term: "PER MONTH",
        plans: ['Limited hours', 'Limited projects'],
        buttonTitle: "Get started",
        buttonLink: "/page/pricing-packages",
    },
    {
        icon: "line-icon-Business-Mens",
        title: "ADVANCED",
        price: "$1200",
        term: "PER MONTH",
        plans: ['Unlimited hours', 'Unlimited projects', 'Unlimited variations'],
        buttonTitle: "Get started",
        buttonLink: "/page/pricing-packages",
        popular: {
            isPopular: true
        }
    },
    {
        icon: "line-icon-Business-ManWoman",
        title: "BUSINESS",
        price: "$900",
        term: "PER MONTH",
        plans: ['Unlimited hours', 'Unlimited projects'],
        buttonTitle: "Get started",
        buttonLink: "#"
    }

]

const pricingTable03MonthData = [
    {
        icon: "line-icon-Boy",
        title: "BASIC PLAN",
        subtitle: "Basic features",
        price: "$9.99",
        term: "monthly",
        plans: [
            `<strong>5</strong> Domains`,
            `<strong>2 GB</strong> File upload`,
            `<strong>20 GB</strong> Secure storage`,
            `<strong>Unlimited</strong> bandwidth`
        ],
        buttonTitle: "Register now",
        buttonLink: "/page/pricing-packages",

    },
    {
        icon: "line-icon-Business-ManWoman",
        title: "STANDARD PLAN",
        subtitle: "MOST POPULAR",
        price: "$19.99",
        term: "monthly",
        plans: [
            `<strong>10</strong> Domains`,
            `<strong>2 GB</strong> File upload`,
            `<strong>40 GB</strong> Secure storage`,
            `<strong>Unlimited</strong> bandwidth`
        ],
        buttonTitle: "Register now",
        buttonLink: "/page/pricing-packages",
        popular: {
            isPopular: true
        }
    },
    {
        icon: "line-icon-Business-Mens",
        title: "PREMIUM PLAN",
        subtitle: "ALL YOU MAY NEED",
        price: "$29.99",
        term: "monthly",
        plans: [
            `<strong>20</strong> Domains`,
            `<strong>4 GB</strong> File upload`,
            `<strong>60 GB</strong> Secure storage`,
            `<strong>Unlimited</strong> bandwidth`
        ],
        buttonTitle: "Register now",
        buttonLink: "/page/pricing-packages",
    },
]
const pricingTable03YearData = [
    {
        icon: "line-icon-Boy",
        title: "BASIC PLAN",
        subtitle: "Basic features",
        price: "$90.99",
        term: "yearly",
        plans: [
            `<strong>5</strong> Domains`,
            `<strong>2 GB</strong> File upload`,
            `<strong>20 GB</strong> Secure storage`,
            `<strong>Unlimited</strong> bandwidth`
        ],
        buttonTitle: "Register now",
        buttonLink: "/page/pricing-packages",

    },
    {
        icon: "line-icon-Business-ManWoman",
        title: "STANDARD PLAN",
        subtitle: "MOST POPULAR",
        price: "$199.99",
        term: "yearly",
        plans: [
            `<strong>10</strong> Domains`,
            `<strong>2 GB</strong> File upload`,
            `<strong>40 GB</strong> Secure storage`,
            `<strong>Unlimited</strong> bandwidth`
        ],
        buttonTitle: "Register now",
        buttonLink: "/page/pricing-packages",
        popular: {
            isPopular: true
        }
    },
    {
        icon: "line-icon-Business-Mens",
        title: "PREMIUM PLAN",
        subtitle: "ALL YOU MAY NEED",
        price: "$290.99",
        term: "yearly",
        plans: [
            `<strong>20</strong> Domains`,
            `<strong>4 GB</strong> File upload`,
            `<strong>60 GB</strong> Secure storage`,
            `<strong>Unlimited</strong> bandwidth`
        ],
        buttonTitle: "Register now",
        buttonLink: "/page/pricing-packages",
    },
]

const pricingTable04 = [
    // {
    //     title: "BASIC PLAN",
    //     subtitle: "Einmal Zahlung",
    //     price: "3300 €",
    //     term: "Startet ab",
    //     plans: [
    //         "✔ Design und Entwicklung", "✔ +25€ pro Monat Hosting", "✔ 150 € pro zusätzlicher Seite ab der sechsten Seite","⊘ Support","⊘ Lifetime Updates"
    //     ],
    //     buttonTitle: "Jetzt starten",
    //     buttonLink: "/kontakt",
    // },
    {
        title: "STANDARD PLAN",
        subtitle: "BELIEBT",
        price: "179 €",
        term: "PRO MONAT",
        plans: [
          "✔ Design und Entwicklung",
        //   "✔ Inklusive Hosting (für die ersten 12 Monate)",
          "✔ 150 € einmalig pro zusätzliche Seite ab der sechsten Seite",
          "✔ Support und kleine Änderungen inklusive (erstes Jahr)",
          "✔ Lifetime Updates",
          "✔ 12 Monate Mindestlaufzeit",
          "✔ Nach 12 Monaten nur 20 € monatlich für Hosting",
          "✔ Änderungen nach 12 Monaten auf Stundenbasis",
          "✔ Monatliche Kündigung möglich (bei vorzeitiger Kündigung vor Ablauf der 12 Monate wird die Webseite offline genommen, bis die Zahlung abgeschlossen ist)",
          "✔ Quellcode-Übergabe auf Wunsch nach vollständiger Zahlung"
        ],
        buttonTitle: "Jetzt starten",
        buttonLink: "/kontakt",
        popular: {
          isPopular: true,
          color: "#001F3F"
        }
    },
    // {
    //     title: "ONE-PAGER",
    //     subtitle: "Einmal Zahlung",
    //     price: "2500 €",
    //     term: "Startet ab",
    //     plans: [
    //         "✔ Design und Entwicklung", "✔ +25€ pro Monat Hosting","⊘ Support","⊘ Lifetime Updates"

    //     ],
    //     buttonTitle: "Jetzt starten",
    //     buttonLink: "/kontakt",
    // }
]

export { pricingTable01, pricingTable02, pricingTable03MonthData, pricingTable03YearData, pricingTable04 }